import * as moment from 'moment';
import { environment } from '@environments/environment';
import { BookingStep } from '@ibe/models/ui';

moment.locale(environment.locale);

/**
 * BOOKING STATE SETUP
 *
 * This module includes all thing necessary to speed up development of the booking feature
 * Should include mock states for when the booking process starts in the middle of the flow
 */
export const DATES_BOOKING_STEPS_STATE = [
	new BookingStep(
		{
			name: 'LISBOA',
			code: 'LIS',
			label: 'LISBOA',
			direct: null,
			location: {
				city: 'Lisbon',
				cityName: 'LIS',
				alias: `Lisbon, Portugal(SunD'or,×œ×™×¡×‘×•×Ÿ, ×¤×•×¨×˜×•×’×œ(×¡××Ÿ ×“×•×¨, ×œ×™×¡×‘×•×Ÿ,
				×¤×•×¨×˜×•×’×œ, Portugal, LIS, ×š×Ÿ×“× ××ž, ×¤××¨××•×¢×©×š, khxcui, puryudk`,
				country: 'Portugal',
				countryName: 'PT'
			},
			milesAndGo: null
		},
		{
			name: 'Adolfo Suarez-Barajas',
			code: 'MAD',
			label: 'Adolfo Suarez-Barajas',
			direct: null,
			location: {
				city: 'Madrid',
				cityName: 'MAD',
				alias:
					'Madrid, Spain,×ž×“×¨×™×“, ×¡×¤×¨×“, MAD, ×¦×©×’×¨×Ÿ×’, ×“×¤×©×Ÿ×ž, nsrhs, xprs',
				country: 'Spain',
				countryName: 'ES'
			},
			milesAndGo: null
		},
		moment().toDate()
	),
	new BookingStep(
		{
			name: 'Adolfo Suarez-Barajas',
			code: 'MAD',
			label: 'Adolfo Suarez-Barajas',
			direct: null,
			location: {
				city: 'Madrid',
				cityName: 'MAD',
				alias:
					'Madrid, Spain,×ž×“×¨×™×“, ×¡×¤×¨×“, MAD, ×¦×©×’×¨×Ÿ×’, ×“×¤×©×Ÿ×ž, nsrhs, xprs',
				country: 'Spain',
				countryName: 'ES'
			},
			milesAndGo: null
		},
		{
			name: 'LISBOA',
			code: 'LIS',
			label: 'LISBOA',
			direct: null,
			location: {
				city: 'Lisbon',
				cityName: 'LIS',
				alias: `Lisbon, Portugal(SunD'or,×œ×™×¡×‘×•×Ÿ, ×¤×•×¨×˜×•×’×œ(×¡××Ÿ ×“×•×¨, ×œ×™×¡×‘×•×Ÿ,
					×¤×•×¨×˜×•×’×œ, Portugal, LIS, ×š×Ÿ×“× ××ž, ×¤××¨××•×¢×©×š, khxcui, puryudk`,
				country: 'Portugal',
				countryName: 'PT'
			},
			milesAndGo: null
		},
		moment().add(15, 'days').toDate()
	)
];

export const DATES_BOOKING_STEPS_MULTICITY_STATE = [
	new BookingStep(
		{
			name: 'LISBOA',
			code: 'LIS',
			label: 'LISBOA',
			direct: true,
			location: {
				city: 'Lisbon',
				cityName: 'LIS',
				alias: `Lisbon, Portuga`,
				country: 'Portugal',
				countryName: 'PT'
			},
			milesAndGo: null
		},
		{
			name: 'Adolfo Suarez-Barajas',
			code: 'MAD',
			label: 'Adolfo Suarez-Barajas',
			direct: true,
			location: {
				city: 'Madrid',
				cityName: 'MAD',
				alias:
					'Madrid, Spain',
				country: 'Spain',
				countryName: 'ES'
			},
			milesAndGo: null
		},
		moment().toDate()
	),
	new BookingStep(
		{
			name: 'Adolfo Suarez-Barajas',
			code: 'MAD',
			label: 'Adolfo Suarez-Barajas',
			direct: true,
			location: {
				city: 'Madrid',
				cityName: 'MAD',
				alias: 'Madrid, Spain',
				country: 'Spain',
				countryName: 'ES'
			},
			milesAndGo: null
		},
		{
			name: 'LISBOA',
			code: 'LIS',
			label: 'LISBOA',
			direct: true,
			location: {
				city: 'Lisbon',
				cityName: 'LIS',
				alias: 'Lisbon, Portugal',
				country: 'Portugal',
				countryName: 'PT'
			},
			milesAndGo: null
		},
		moment().add(15, 'days').toDate()
	),
	new BookingStep(
		{
			name: 'Adolfo Suarez-Barajas',
			code: 'MAD',
			label: 'Adolfo Suarez-Barajas',
			direct: true,
			location: {
				city: 'Madrid',
				cityName: 'MAD',
				alias:
					'Madrid, Spain',
				country: 'Spain',
				countryName: 'ES'
			},
			milesAndGo: null
		},
		{
			name: 'LISBOA',
			code: 'LIS',
			label: 'LISBOA',
			direct: true,
			location: {
				city: 'Lisbon',
				cityName: 'LIS',
				alias: `Lisbon, Portugal`,
				country: 'Portugal',
				countryName: 'PT'
			},
			milesAndGo: null
		},
		moment().add(20, 'days').toDate()
	)
];



const flights = {
	MAD: {
		name: 'Adolfo Suarez-Barajas',
		code: 'MAD',
		label: 'Adolfo Suarez-Barajas',
		direct: true,
		location: {
			city: 'Madrid',
			cityName: 'MAD',
			alias: 'Madrid, Spain',
			country: 'Spain',
			countryName: 'ES'
		},
		milesAndGo: null
	},
	LIS: {
		name: 'LISBOA',
		code: 'LIS',
		label: 'LISBOA',
		direct: true,
		location: {
			city: 'Lisbon',
			cityName: 'LIS',
			alias: 'Lisbon, Portugal',
			country: 'Portugal',
			countryName: 'PT'
		},
		milesAndGo: null
	}
};

export const DATES_BOOKING_STEPS_STOPOVER_STATE = [
	new BookingStep(flights.MAD, flights.LIS, moment().add(5, 'days').toDate(), { days: 5, airport: flights.LIS, when: 'inbound' }),
	new BookingStep(flights.LIS, flights.MAD, moment().add(15, 'days').toDate())
];
